import { ChangeEvent } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { AadhaarNumber, AdharPlaceholder, Continue, PAN, PanPlaceholder, Previous } from "../../../../Constant";
import { useAppDispatch, useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import ShowError from "../../common/ShowError";
import { BankLogoList } from "./BankLogoList";
import { BusinessFormCommonProps } from "../../../../Type/FormLayoutType";
import { setBankDetailsForm } from "../../../../Redux-Toolkit/Reducers/FormLayout/FormWizardTwoSlice";

const BankInfoForm = ({ callbackActive }: BusinessFormCommonProps) => {
  const { bankDetailsForm } = useAppSelector((state) => state.formWizardTwo);
  const { aadhaarNumber, panNumber, bankName } = bankDetailsForm;
  const dispatch = useAppDispatch();

  const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = name === "rememberNextTime" ? event.target.checked : event.target.value;
    dispatch(setBankDetailsForm({ ...bankDetailsForm, [name]: value }));
  };

  const handleNextButton = () => {
    if (aadhaarNumber !== "" && panNumber !== "" && bankName !== "") {
      callbackActive(3);
    } else {
      ShowError();
    }
  };

  return (
    <Form onSubmit={(event) => event.preventDefault()} className="g-3 needs-validation" noValidate>
      <Row>
        <Col sm="6" className="bank-search">
          <Label check>{AadhaarNumber}<span className="txt-danger">*</span></Label>
          <Input value={aadhaarNumber} name="aadhaarNumber" onChange={getUserData} type="search" placeholder={AdharPlaceholder} />
        </Col>
        <Col sm="6" className="bank-search">
          <Label check>{PAN}<span className="txt-danger">*</span></Label>
          <Input type="search" placeholder={PanPlaceholder} value={panNumber} name="panNumber" onChange={getUserData} />
        </Col>
        <BankLogoList getUserData={getUserData}/>
        <Col xs="12" className="text-end mt-3">
          <Btn color="primary" onClick={() => callbackActive(1)}>{Previous}</Btn>
          <Btn className="ms-1" color="primary" onClick={handleNextButton}>{Continue}</Btn>
        </Col>
      </Row>
    </Form>
  );
};

export default BankInfoForm;
